import React from "react";
import { Chart } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { H4, Card, Callout } from "@blueprintjs/core";
import { generic_colors } from "./Colors";

class PieChart extends React.Component {
  constructor(props) {
    super(props);
    this.chartRef = React.createRef();
  }

  componentDidUpdate() {
    if (this.props.labels !== undefined && this.props.data !== undefined) {
      this.myChart.data.labels = this.props.labels;
      this.myChart.data.datasets[0].data = this.props.data;
      this.myChart.update();
    } else {
      this.myChart.clear();
    }
  }

  componentDidMount() {
    const colors =
      this.props.colors === undefined ? generic_colors : this.props.colors;
    //const unit = this.props.unit !== undefined ? this.props.unit : "";
    const total = this.props.data.reduce(
      (previousValue, currentValue) => previousValue + currentValue,
      0
    );

    var options = {
      responsive: true,
      maintainAspectRatio: true,
    };

    if (
      this.props.fixedLabels !== undefined &&
      this.props.fixedLabels === true
    ) {
      options.plugins = {
        legend: {
          labels: {
            color: JSON.parse(localStorage.getItem("dark")) ? "white" : "black",
          },
        },
        datalabels: {
          color: "black",
          // display label on the outside of the pie (use padding to add space if nedded)
          //textAlign: "center", anchor: "end", align: "end",
          //formatter: function (value, context) { return `${context.dataset.labels[context.dataIndex]}\n${value} ${unit}`; },
          textAlign: "center",
          formatter: function (value, context) {
            return `${Math.round((value / total) * 100)}%`;
          },
          font: { size: 12 },
        },
      };
      options.layout = { padding: { left: 5, right: 5, top: 5, bottom: 5 } };
    }

    this.myChart = new Chart(this.chartRef.current, {
      type: "pie" /* could be "doughnut" */,
      plugins:
        this.props.fixedLabels !== undefined && this.props.fixedLabels === true
          ? [ChartDataLabels]
          : [],
      options: options,
      data: {
        label: this.props.title,
        labels: this.props.labels,
        datasets: [
          {
            labels: this.props.labels,
            data: this.props.data,
            backgroundColor: colors,
            borderWidth: 0,
          },
        ],
      },
    });
  }

  render() {
    return (
      <Card
        className={
          this.props.big !== undefined && this.props.big === "true"
            ? "big-chart-container"
            : "little-chart-container"
        }
      >
        <H4 className="chart-title noselect">{this.props.title}</H4>
        <canvas ref={this.chartRef} />
        {this.props.legend && <Callout intent="primary">{this.props.legend}</Callout>}
      </Card>
    );
  }
}

export default PieChart;
